import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("newsletter-compact", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateNewsletterCompact = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateNewsletterCompact?.destroy();
  },
});
